import { fonts } from "../fonts";
export const fontsCss = (dt) => {
    const fonts = findFontsInTokens(dt);
    const css = [];
    for (const font of fonts) {
        for (const variant of font.files) {
            css.push(`@font-face {
          font-display: swap;
          font-family: '${font.name}';
          font-style: ${variant.style};
          font-weight: ${variant.weight};
          src: url('https://pixel.infinicloud.app/fonts/${variant.file}') format('${variant.format}');
        }`);
        }
    }
    return css.join(" ");
};
export const findFontsInTokens = (dt) => {
    const fontsCollection = [];
    const dtString = JSON.stringify(dt);
    for (const index in fonts) {
        const rx = new RegExp(`"'?${fonts[index].name}'?"`);
        if (rx.test(dtString)) {
            fontsCollection.push(fonts[index]);
        }
    }
    return fontsCollection;
};
